<template>
  <div class="section04">
    <div class="headersection mt-3">
      <i class="fad fa-bullhorn"></i> BroadCast
    </div>
    <div class="bccontainer">
      <div class="swiper broadcast bcsw">
        <swiper class="swiper" :options="swiperOptions">
          <swiper-slide
            class="slide"
            v-for="(bc, index) in Boardcast"
            :key="index"
            ><img :src="bc.url" alt="BFCO Boardcast"
          /></swiper-slide>
        </swiper>
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import { HTTP } from "@/services/http-common";

export default {
  name: "boardcast-component",
  components: {
    Swiper,
    SwiperSlide,
  },
  directives: {
    swiper: directive,
  },
  data() {
    return {
      Boardcast: null,
      swiperOptions: {
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        loop: true,
        loopFillGroupWithBlank: true,
      },
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      HTTP.get(`system/broadcast`)
        .then((resp) => {
          this.Boardcast = resp.data.data;
        })
        .catch((err) => {
          this.$toast.error(
            err.data.msg != undefined
              ? err.data.msg
              : "ไม่สามารถโหลดได้ กรุณาลองใหม่"
          );
        });
    },
  },
};
</script>

<style></style>
